import PatientReferralDialog from './PatientReferralDialog';

export default PatientReferralDialog;
